import { BehaviorParameters } from 'rangeConfig/@types';
import { HierarchyUtils } from '@inter-ikea-core/core';
import { ErrorMessages } from '@inter-ikea-storageone/range';
import { hideNoFramesInSceneErrorMessage } from '../rules/hideMenuRules';

const addAndReplaceToTarget = ({ coreApi, props, rootState }: BehaviorParameters) => {
  const target = coreApi.entities.findSelectedEntity();
  const productToAdd = rootState.products.inMarket.find(
    p => p.coreProductId === props.coreProductId
  );
  if (!target || !productToAdd) {
    return;
  }
  const existingChild = HierarchyUtils.children(target).find(child =>
    coreApi.entities.isProductType(child, productToAdd.type)
  );
  if (existingChild) {
    coreApi.products.replace(existingChild.id, props.coreProductId);
  } else {
    const placementResult = coreApi.products.addToTarget(props.coreProductId, target);
    if (!placementResult.valid && placementResult.errors && placementResult.errors.length > 0) {
      if (!hideNoFramesInSceneErrorMessage(coreApi)) {
        coreApi.emit.onPlacementAttempt(ErrorMessages.NoFramesInScene);
      }
      coreApi.entities.disposeCollidingEntities(placementResult.errors);
    }
  }
};

export default addAndReplaceToTarget;
